<script>
import Layout from "@/router/layouts/main";
import Drawer from "vue-simple-drawer";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrHesapKodlari from "@/models/StrHesapKodlari";
import AddEdit from "./AddEdit.vue";
export default {
  mixins: [Api, Sabit, StrHesapKodlari],
  page: {
    title: "Hesap Kodları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
    Drawer,
  },
  data() {
    return {
      title: this.$t("StrHesapKodlari.Title"),
      items: [
        {
          text: this.$t("StrHesapKodlari.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrHesapKodlari.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrHesapKodlari.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      Filter: {
        Hesapkoduid: null,
        Aciklama: "",
      },
      siralama:"&Asc=Kod",
      FormTitle: "",
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      AddUstId: "",
      FilitrelemePenceresi: false,

    };
  },

  methods: {
    Get() {
      let Filter="";
       if(this.Filter.Aciklama!=null && this.Filter.Aciklama!=""){
        Filter=Filter+"&Aciklama="+this.Filter.Aciklama;
      }

      if(this.Filter.Kod!=null && this.Filter.Kod!=""){
        Filter=Filter+"&Kod="+this.Filter.Kod;
      }

      if(this.siralama!=null && this.siralama!=""){
        Filter=Filter+this.siralama;
      }

      this.ActionsFilterGet({ Service: "StrHesapKodlari", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                  <div class="search-box me-2 mb-2 d-inline-block">
                    <div class="position-relative">
                      <input type="text" @input="Filter.Aciklama.length >= 3 || Filter.Aciklama.length == 0 ? Get() : ''" v-model="Filter.Aciklama" class="form-control" :placeholder="$t('StrHesapKodlari.Page.Arama')" />
                      <i class="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2" @click="rightDrawer()">
                      <i class="mdi mdi-text-search me-1"></i>
                      {{ $t("StrBirimHarcamaLimit.Page.Filtreleme") }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th style="width:150px">{{ $t("StrHesapKodlari.Table.Kod") }}
                      <i style="margin-left:10px" v-if="siralama!='&Asc=Kod'" @click="siralama='&Asc=Kod', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Kod'" @click="siralama='&Desc=Kod', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   </th>
                      <th>{{ $t("StrHesapKodlari.Table.Aciklama") }}
                      <i style="margin-left:10px" v-if="siralama!='&Asc=Aciklama'" @click="siralama='&Asc=Aciklama', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Aciklama'" @click="siralama='&Desc=Aciklama', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   </th>
                     <!--<th>{{ $t("StrHesapKodlari.Table.Parasalustlimit") }}</th>
                      <th style="width: 85px; text-align: center;">{{ $t("StrHesapKodlari.Table.Islem") }}</th>--> 
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Kod }}</th>
                      <td>{{ Data.Aciklama }}</td>
                     <!--<td>
                        <template v-if="Data.Kod.length == 11">
                          {{ Data.Parasalustlimit | TrParaFormat }}
                        </template>
                      </td>
                      <td style="width: 85px; text-align: center;">
                        <b-button-group>
                          <b-button v-if="Data.Kod.length == 11" v-b-modal.StrHesapKodlari @click="(DataUpdate = Data), (AddEdit = 'Edit')" variant="success"><i class="far fa-edit"></i></b-button>
                        </b-button-group>
                       
                      </td>--> 
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" :AddUstId="AddUstId" />

      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div  style="width: 400px;" v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrBirimHarcamaLimit.Filtreleme.Title") }}
            </h5>
          </div>
          <div >
            {{ $t("StrBirimHarcamaLimit.Filtreleme.Content") }}
            <br><br>
            

            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("StrHesapKodlari.Filtreleme.Kod") }}</label>
              <b-form-input  style="width:400px" for="text" v-model="Filter.Kod" value=""></b-form-input>
            </div>

            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("StrHesapKodlari.Filtreleme.Aciklama") }}</label>
              <b-form-input  style="width:400px" for="text" v-model="Filter.Aciklama" value=""></b-form-input>
            </div>


            <b-button @click="Get(),rightDrawer()" class="btn btn-primary" variant="primary"> {{ $t("StrHesapKodlari.Filtreleme.Button") }}</b-button>
          </div>
        </div>
      </Drawer>

    </Layout>
  </Loader>
</template>
<style scoped>
.list-unstyled li:hover {
  transition: 0.5s ease-in all;
  background-color: rgb(247, 247, 247);
}
</style>
